export default __webpack_public_path__ + "static/retail-software-testing-40b646c3e363a3819d60d67bc091242b.jpg";